import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column gap-1" }
const _hoisted_2 = { class: "body m font-medium" }
const _hoisted_3 = { class: "body s font-regular" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconName } from '@/models/icon-types';
import { ToastType, useToasterStore } from '@/stores/useToasterStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ToasterComponent',
  setup(__props) {

const toastStore = useToasterStore();

function getIconName(type: ToastType): IconName {
  switch (type) {
    case 'info':
      return 'info';
    case 'success':
      return 'circle-check';
    default:
      return 'warning';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_TransitionGroup, {
      name: "toast",
      tag: "ul",
      class: "toaster-wrapper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toastStore).toasts, (toast) => {
          return (_openBlock(), _createElementBlock("li", {
            key: toast.id,
            class: _normalizeClass(['toast', toast.type])
          }, [
            _createVNode(AppIcon, {
              name: getIconName(toast.type),
              size: "body-xl"
            }, null, 8, ["name"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(toast.title), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(toast.body), 1)
            ]),
            _createVNode(AppIcon, {
              id: "close_icon",
              name: "X",
              onClick: () => _unref(toastStore).removeToast(toast.id),
              size: "body-xl",
              "class-name": "clickable"
            }, null, 8, ["onClick"])
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})